<template>
  <div>
    <div v-if="file && file.extension" class="relative">
      <div class="pill">
        <button
          class="btn d-flex align-items-center px-2 py-0 gap-1"
          @click="openPreview"
          style="width: 100%"
          target="_blank"
          v-b-tooltip.hover
          :title="originalFilename"
        >
          {{ fileName }}
          <div
            class="button-close"
            v-if="deletable"
            @click="
              event => {
                event.stopPropagation();
                $emit('delete');
              }
            "
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.99967 0.333008C3.32367 0.333008 0.333008 3.32367 0.333008 6.99967C0.333008 10.6757 3.32367 13.6663 6.99967 13.6663C10.6757 13.6663 13.6663 10.6757 13.6663 6.99967C13.6663 3.32367 10.6757 0.333008 6.99967 0.333008M9.80434 8.86168L8.86168 9.80434L6.99967 7.94234L5.13767 9.80434L4.19501 8.86168L6.05701 6.99967L4.19501 5.13767L5.13767 4.19501L6.99967 6.05701L8.86168 4.19501L9.80434 5.13767L7.94234 6.99967L9.80434 8.86168Z"
                fill="currentColor"
              />
            </svg>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "file-item",
  components: {},
  props: {
    imageStyle: {
      type: String,
      default: "height: 200px; width: 200px; object-fit: contain;"
    },
    deletable: Boolean,
    previewPdf: {
      type: Boolean,
      default: true
    },
    previewImage: {
      type: Boolean,
      default: true
    },
    file: {
      default: undefined
    }
  },
  data() {
    return {
      preview: null
    };
  },
  watch: {
    file: {
      handler(value) {
        if (value) {
          if (value.preview) {
            this.preview = value.preview;
            return;
          }
          const reader = new FileReader();
          reader.onload = event => {
            this.preview = event.target.result;
          };
          reader.readAsDataURL(value.file || value);
        }
      },
      immediate: true
    }
  },
  computed: {
    isBase64() {
      return (this.file?.preview || this.preview)?.includes("data:");
    },
    originalFilename() {
      if (this.file?.file?.name) {
        return this.file?.file?.name;
      }
      const filename = this.preview.split("/").pop();
      let cleanFilename = filename.split("?")[0];
      return cleanFilename;
    },
    fileName() {
      const maxLength = 24;
      let cleanFilename = this.originalFilename;
      if (cleanFilename.length > maxLength) {
        cleanFilename = cleanFilename.slice(0, maxLength) + "...";
      }
      return cleanFilename;
    }
  },
  methods: {
    openPreview() {
      if (!this.isBase64) {
        window.open(this.preview, "_blank");
      }
      let [header, base64data] = this.preview.split(",");
      let mime = header.match(/:(.*?);/)[1];
      let blob = new Blob(
        [
          new Uint8Array(
            atob(base64data)
              .split("")
              .map(c => c.charCodeAt(0))
          )
        ],
        { type: mime }
      );
      if (this.objectUrl) {
        URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = null;
      }
      this.objectUrl = URL.createObjectURL(blob);
      open(this.objectUrl);
    }
  }
};
</script>

<style scoped lang="scss">
.button-close {
  //position: absolute;
  //top: 0;
  //right: 0;
  border-radius: 50%;
  padding: 5px;
  cursor: pointer;
  color: #454646;
  :hover {
    color: #f83a11;
  }
}

.pdf-preview {
  .button-close {
    //top: 4px;
    //right: -10px;
  }
}

.pill {
  width: fit-content;
  display: flex;
  align-items: center;
  background: #eef3f7;
  border-radius: 4px;
  button {
    color: var(--primary-blue-500-base, #1b77df);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
}
</style>
